import { lazy } from "react";
import { enumPermisosGestionItau } from "./enumPermisosGestionItau";
/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/**
 * Corresponsalia tu llave
 */
const BloqueoConveniosItau = lazy(() =>
  import("./Views/BloqueosConvenios/BloqueoItau")
);

const CrearBloqueoConveniosItau = lazy(() =>
  import("./Views/BloqueosConvenios/CrearBloqueoItau")
);

const BloqueoComerciosItau = lazy(() =>
  import("./Views/BloqueoComercios/BloqueoComercios")
);

const CrearBloqueoComerciosItau = lazy(() =>
  import("./components/ConsultaComerciosBloqueados/BloqueoCommerce")
);

const ConveniosListaItau = lazy(() => import("./Views/Convenios/Convenios"));

const ConveniosItau = lazy(() => import("./GestionItau"));

const listPermissions = Object.values(enumPermisosGestionItau);

export const listPermissionsItau = listPermissions;

const routesItau = {
  link: "/GestionTransaccional/itau",
  label: <AppIcons Logo={"ITAU"} name="Gestión Itaú" />,
  component: ConveniosItau,
  permission: [...listPermissionsItau],
  subRoutes: [
    {
      link: "/GestionTransaccional/itau/bloqueo-convenios-itau",
      label: (
        <AppIcons
          Logo={"BLOQUEO_CONVENIOS_ITAU"}
          name="Bloqueo Convenios Itaú"
        />
      ),
      component: BloqueoConveniosItau,
      permission: [enumPermisosGestionItau.BLOQUEOS_CONVENIOS_ITAU],
      subRoutes: [
        {
          link: "/GestionTransaccional/itau/bloqueo-convenios-itau/crear",
          label: (
            <AppIcons
              Logo={"BLOQUEO_CONVENIOS_ITAU"}
              name={"Bloqueo Convenios Itaú"}
            />
          ),
          component: CrearBloqueoConveniosItau,
          permission: [enumPermisosGestionItau.BLOQUEOS_CONVENIOS_ITAU],
        },
        {
          link: "/GestionTransaccional/itau/bloqueo-convenios-itau/:id",
          label: (
            <AppIcons
              Logo={"BLOQUEO_CONVENIOS_ITAU"}
              name={"Bloqueo Convenios Itaú"}
            />
          ),
          component: CrearBloqueoConveniosItau,
          permission: [enumPermisosGestionItau.BLOQUEOS_CONVENIOS_ITAU],
        },
      ],
    },
    {
      link: "/GestionTransaccional/itau/convenios",
      label: (
        <AppIcons
          Logo={"BLOQUEO_CONVENIOS_ITAU"}
          name={"Convenios Recaudo Itaú"}
        />
      ),
      component: ConveniosListaItau,
      permission: [enumPermisosGestionItau.CONVENIOS_ITAU],
    },
    {
      link: "/GestionTransaccional/itau/bloqueo-comercios",
      label: <AppIcons Logo={"BLOQUEO_CONVENIOS_ITAU"} name={"Bloqueo y Desbloqueo Interno Comercios Itaú"}/>,
      component: BloqueoComerciosItau,
      permission: [enumPermisosGestionItau.BLOQUEOS_COMERCIOS_ITAU],
      subRoutes: [
        {
          link: "/GestionTransaccional/itau/bloqueo-comercios/crear",
          label: <AppIcons Logo={"BLOQUEO_CONVENIOS_ITAU"} name="Bloqueo y Desbloqueo Interno Comercios Itaú" />,
          component: CrearBloqueoComerciosItau,
          permission: [enumPermisosGestionItau.BLOQUEOS_COMERCIOS_ITAU],
        }
      ]
    },
  ],
};

export default routesItau;
